import { useQuery } from 'react-query';

import { HOME_QUERY_KEYS } from '../../constants';
import { mapHomeProducts } from '../../mappers';
import { fetchAllUserProducts, HomeProduct } from '../../request';

/**
 * Gated on the session being ready — hx-accounts must not call authenticated
 * APIs while Cognito refresh is in flight.
 *
 * Not cached: overrides the app-wide 5-minute `staleTime` so each mount (or
 * remount after leaving `/`) hits the network again.
 */
export const useGetAllUserProducts = (enabled: boolean) =>
  useQuery<HomeProduct[], Error, HomeProduct[]>(
    [HOME_QUERY_KEYS.ALL_USER_PRODUCTS],
    ({ signal }) => fetchAllUserProducts(signal),
    {
      enabled,
      select: mapHomeProducts,
      staleTime: 0,
      cacheTime: 0,
    }
  );
